import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { isAuthenticated } from "../helpers/authUtils";
import LuminateLogo from "assets/images/logo.png";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  adminSignIn,
  updateUsermode,
} from "actions/Auth";

class AdminSignin extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
    };
  }

  componentDidMount() {
    this.props.updateUsermode("Staff");
    this.checkAndNavigate();
  }

  componentDidUpdate(prevProps) {
    if (this.props.showMessage && !prevProps.showMessage) {
      this.props.hideMessage();
    }
    this.checkAndNavigate();
  }

  checkAndNavigate = () => {
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.replace("/admin/dashboard");
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.showAuthLoader();
    this.props.adminSignIn({ email: this.state.email, password: this.state.password });
  }

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {
    const { email, password } = this.state;
    const { showMessage, loader, alertMessage } = this.props;

    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="../" title="Luminate">
              <img src={LuminateLogo} alt="FedPolyLogo" title="FedPolyLogo" />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Admin Login</h1>
            </div>

            <div className="app-login-form">
              <form onSubmit={this.handleSubmit}>
                <fieldset>
                  <TextField
                    label={<IntlMessages id="appModule.email" />}
                    fullWidth
                    onChange={this.handleInputChange}
                    value={email}
                    name="email"
                    margin="normal"
                    type="email"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={this.handleInputChange}
                    value={password}
                    name="password"
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button type="submit" variant="contained" style={{ backgroundColor: "#540000", color: "#ffffff" }}>
                      <IntlMessages id="appModule.signIn" />
                    </Button>
                    <span>
                      Existing staff? 
                      <Link to="./CreateStaffAccount" className="pl-1">
                        Create Account
                      </Link>
                    </span>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link to="./ForgotPassword">
                      <IntlMessages id="appModule.forgotPassword" />
                    </Link>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, adminUser } = auth;
  const authUser = adminUser;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  adminSignIn,
  hideMessage,
  showAuthLoader,
  updateUsermode,
})(AdminSignin);